import { render, staticRenderFns } from "./editminappconfig.vue?vue&type=template&id=2e0651aa&"
import script from "./editminappconfig.vue?vue&type=script&lang=ts&"
export * from "./editminappconfig.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "editminappconfig.vue"
export default component.exports